import { method } from 'lodash'
import request, { ResponseData } from '@/utils/request'

// 获取分组
export async function fetchDepartmentList() {
  return request('/api/v1/training/dialogcase/group', {
    method: 'get',
  })
}

export async function fetchCaseList(params) {
  return request('/api/v1/training/dialogcase/search', {
    method: 'post',
    data: params,
  })
}

// 整通会话加入案例
export async function addDialog(params) {
  return request('/api/v1/training/dialogcase/add_dialog', {
    method: 'post',
    data: params,
  })
}

// 片段会话加入案例
export async function addPortion(params) {
  // console.log(params.portions);
  return request('/api/v1/training/dialogcase/portion', {
    method: 'post',
    data: params,
  })
}

// 右边的编辑
export async function updateCase(params) {
  return request('/api/v1/training/dialogcase', {
    method: 'patch',
    data: params,
  })
}

// 右边的删除
export async function deleteCase(params) {
  // console.log('删除的参数',params);
  return request('/api/v1/training/dialog/dialog', {
    method: 'delete',
    data: params,
  })
}

// 批量导入
export async function importFile(params) {
  return request('/api/v1/training/dialogcase/batch/delete', {
    method: 'post',
    data: params,
  })
}

// 查找tenant下的所有 dialog  (会话素材)
export async function dialogList(params) {
  return request('/api/v1/training/dialog/list', {
    method: 'post',
    data: params,
  })
}

// 查找对应tenant下的所有 dialog case segment （会话详情）
export async function dialogcaseSegment(params) {
  // console.log(params);
  return request('/api/v1/training/dialogcasesegment/list', {
    method: 'post',
    data: params,
  })
}

export async function importDialogFile(params) {
  // console.log('====================================')
  // console.log(params)
  // console.log('====================================')

  //导入上传按钮
  return request('/api/v1/sys/dialog_case/upload', {
    method: 'post',
    data: params,
  })
}

export async function importDialogFileDownloadCenter(params) {
  return request('/api/v1/sys/dialog_case/upload_url', {
    method: 'post',
    data: params,
  })
}

//筛选素材库
export async function searchDialog(params) {
  return request('/api/v1/training/dialog/list', {
    method: 'post',
    data: params,
  })
}

export async function dialogDetail(params) {
  return request('/api/v1/training/dialogcase/detail', {
    method: 'post',
    data: params,
  })
}

//获取管理员和一线客服列表
export async function usersList(params) {
  return request('/api/v1/users/list', {
    method: 'post',
    data: params,
  })
}

//引入快捷语列表
export async function importShortcutsList(params) {
  return request('/api/v1/sys/phrase/list', {
    method: 'post',
    data: params,
  })
}
